import { computed, inject, Injectable, Signal, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProviderTokenSlot } from '../models/provider-token.model';
import { ProviderTokenService } from './provider-token.service';

export type ProviderTokenLadestatus = 'laedt' | 'fehler' | 'bereit';

@Injectable({ providedIn: 'root' })
export class ProviderTokenStatusService {
  private readonly service = inject(ProviderTokenService);
  private readonly _slots = signal<ProviderTokenSlot[]>([]);
  private readonly _status = signal<ProviderTokenLadestatus>('laedt');
  private anfrage?: Subscription;

  readonly slots: Signal<ProviderTokenSlot[]> = this._slots.asReadonly();
  readonly status: Signal<ProviderTokenLadestatus> = this._status.asReadonly();
  readonly fehlend = computed(() =>
    this._status() === 'bereit' ? this._slots().filter((slot) => !slot.tokenSet).length : 0,
  );

  laden(): void {
    this.anfrage?.unsubscribe();
    this._status.set('laedt');
    this.anfrage = this.service.list().subscribe({
      next: (slots) => {
        this._slots.set(slots);
        this._status.set('bereit');
      },
      error: () => {
        this._slots.set([]);
        this._status.set('fehler');
      },
    });
  }
}
